import { useEffect, useState } from "react";
import { Row, Col, Card, Button, Modal, Form, Table } from "react-bootstrap";
import Breadcrumb from "app/components/Breadcrumb";
import api from "app/services/api";

export default function MachineryShop() {
  const [shops, setShops] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState(null);

  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  const [machine_no, setMachineNo] = useState("");
  const [shop_name, setShopName] = useState("");
  const [status, setStatus] = useState("active");

  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  useEffect(() => {
    fetchShops();
  }, []);

  const fetchShops = () => {
    api
      .get("/api/machinery-shops", {
        withCredentials: true,
      })
      .then((res) => {
        setShops(res.data.machineryShops || []);
      })
      .catch(() => {
        setShops([]);
      });
  };

  const resetForm = () => {
    setMachineNo("");
    setShopName("");
    setStatus("active");
  };

  const handleAddShop = () => {
    if (!shop_name.trim()) {
      setErrorMsg("Please enter machinery shop name");
      setTimeout(() => setErrorMsg(""), 3000);
      return;
    }

    api
      .post(
        "/api/machinery-shops",
        { machine_no, shop_name, status },
        { withCredentials: true }
      )
      .then(() => {
        setSuccessMsg("Machinery shop added successfully");
        fetchShops();
        resetForm();
        setShowModal(false);
        setTimeout(() => setSuccessMsg(""), 3000);
      })
      .catch(() => {
        setErrorMsg("Failed to add machinery shop");
        setTimeout(() => setErrorMsg(""), 3000);
      });
  };

  const handleUpdateShop = () => {
    if (!shop_name.trim()) {
      setErrorMsg("Please enter machinery shop name");
      setTimeout(() => setErrorMsg(""), 3000);
      return;
    }

    api
      .put(
        "/api/machinery-shops/" + editData.id,
        { machine_no, shop_name, status },
        { withCredentials: true }
      )
      .then(() => {
        setSuccessMsg("Machinery shop updated successfully");
        fetchShops();
        resetForm();
        setEditData(null);
        setShowModal(false);
        setTimeout(() => setSuccessMsg(""), 3000);
      })
      .catch(() => {
        setErrorMsg("Failed to update machinery shop");
        setTimeout(() => setErrorMsg(""), 3000);
      });
  };

  const handleDelete = (item) => {
    if (!window.confirm("Delete this machinery shop entry?")) return;

    api
      .delete("/api/machinery-shops/" + item.id, { withCredentials: true })
      .then(() => {
        setSuccessMsg("Machinery shop deleted successfully");
        fetchShops();
        setTimeout(() => setSuccessMsg(""), 3000);
      })
      .catch(() => {
        setErrorMsg("Failed to delete machinery shop");
        setTimeout(() => setErrorMsg(""), 3000);
      });
  };

  const filteredShops = shops.filter(
    (item) =>
      item.shop_name?.toLowerCase().includes(search.toLowerCase()) ||
      item.machine_no?.toLowerCase().includes(search.toLowerCase())
  );

  const totalRows = filteredShops.length;
  const totalPages = rowsPerPage >= totalRows ? 1 : Math.ceil(totalRows / rowsPerPage);
  const startIndex = (currentPage - 1) * rowsPerPage;
  const paginatedShops = filteredShops.slice(startIndex, startIndex + rowsPerPage);

  return (
    <section>
      <Breadcrumb
        routeSegments={[
          { name: "Dashboard", path: "/" },
          { name: "Product", path: "/product/products" },
          { name: "Machinery Shop" },
        ]}
      />

      {successMsg && <div className="alert alert-success">{successMsg}</div>}
      {errorMsg && <div className="alert alert-danger">{errorMsg}</div>}

      <Card body className="mb-3">
        <div className="d-flex justify-content-between align-items-center">
          <h5 className="mb-0">Shop machinery List</h5>

          <div className="d-flex align-items-center">
            <input
              type="text"
              placeholder="Search Machinery Shop"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              style={{
                width: "250px",
                height: "38px",
                paddingLeft: "10px",
                border: "1px solid #d1d1d1",
              }}
            />
            <Button
              style={{ backgroundColor: "#663399", border: "none", marginLeft: "10px" }}
              onClick={() => {
                setEditData(null);
                resetForm();
                setShowModal(true);
              }}
            >
              Add Machinery Shop
            </Button>
          </div>
        </div>
      </Card>

      <Card body>
        <Table bordered hover>
          <thead style={{ backgroundColor: "#cfc7d9" }}>
            <tr>
              <th>Sr No</th>
              <th>Machine No</th>
              <th>Machinery Shop Name</th>
              <th>Manage</th>
            </tr>
          </thead>
          <tbody>
            {paginatedShops.map((item, index) => (
              <tr key={item.id}>
                <td>{startIndex + index + 1}</td>
                <td>{item.machine_no || "-"}</td>
                <td>{item.shop_name}</td>
                <td>
                  <div className="d-flex gap-2">
                    <Button
                      style={{ backgroundColor: "#663399", border: "none" }}
                      onClick={() => {
                        setEditData(item);
                        setMachineNo(item.machine_no || "");
                        setShopName(item.shop_name);
                        setStatus(item.status);
                        setShowModal(true);
                      }}
                    >
                      Edit
                    </Button>
                    <Button variant="danger" onClick={() => handleDelete(item)}>
                      Delete
                    </Button>
                  </div>
                </td>
              </tr>
            ))}
            {paginatedShops.length === 0 && (
              <tr>
                <td colSpan="4" className="text-center">No machinery shops found.</td>
              </tr>
            )}
          </tbody>
        </Table>

        <div className="d-flex justify-content-end align-items-center mt-3">
          <span className="me-2">Rows per page</span>
          <Form.Select
            value={rowsPerPage}
            onChange={(e) => {
              setRowsPerPage(Number(e.target.value));
              setCurrentPage(1);
            }}
            style={{ width: "90px", marginRight: "15px" }}
          >
            <option value={5}>5</option>
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={filteredShops.length}>All</option>
          </Form.Select>

          <Button
            disabled={currentPage === 1}
            onClick={() => setCurrentPage(currentPage - 1)}
          >
            Prev
          </Button>
          <span className="mx-3">
            {currentPage} / {totalPages || 1}
          </span>
          <Button
            disabled={currentPage >= totalPages}
            onClick={() => setCurrentPage(currentPage + 1)}
          >
            Next
          </Button>
        </div>
      </Card>

      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Add Machinery Shop</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row>
              <Col md={12} className="mb-3">
                <Form.Label>Machine Number</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Machine Number"
                  value={machine_no}
                  onChange={(e) => setMachineNo(e.target.value)}
                />
              </Col>
              <Col md={12} className="mb-3">
                <Form.Label>
                  Machinery Shop Name <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter machinery Shop Name"
                  value={shop_name}
                  onChange={(e) => setShopName(e.target.value)}
                />
              </Col>
            </Row>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
          <Button
            style={{ backgroundColor: "#663399", border: "none" }}
            onClick={editData ? handleUpdateShop : handleAddShop}
          >
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
    </section>
  );
}
